import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { RotateCcw, Filter } from "lucide-react";
import { vehicles, agencies, techAreas, scoreBands } from "@/data/opportunities";

export const FilterBar = ({ 
  filters, 
  onFilterChange, 
  onResetFilters 
}) => {
  const hasActiveFilters = 
    filters.vehicle !== "All Vehicles" ||
    filters.agency !== "All Agencies" ||
    filters.tech !== "All Technologies" ||
    filters.scoreBand !== "All Scores";

  return (
    <Card className="shadow-card">
      <CardContent className="p-4">
        <div className="flex flex-col lg:flex-row lg:items-center gap-4">
          <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
            <Filter className="h-4 w-4" />
            <span>Filters</span>
          </div>
          
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            <Select
              value={filters.vehicle}
              onValueChange={(value) => onFilterChange('vehicle', value)}
            >
              <SelectTrigger className="h-9 bg-background">
                <SelectValue placeholder="Contract Vehicle" />
              </SelectTrigger>
              <SelectContent>
                {vehicles.map(vehicle => (
                  <SelectItem key={vehicle} value={vehicle}>
                    {vehicle}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            <Select
              value={filters.agency}
              onValueChange={(value) => onFilterChange('agency', value)}
            >
              <SelectTrigger className="h-9 bg-background">
                <SelectValue placeholder="Agency" />
              </SelectTrigger>
              <SelectContent>
                {agencies.map(agency => (
                  <SelectItem key={agency} value={agency}>
                    {agency}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            <Select
              value={filters.tech}
              onValueChange={(value) => onFilterChange('tech', value)}
            >
              <SelectTrigger className="h-9 bg-background">
                <SelectValue placeholder="Technology Area" />
              </SelectTrigger>
              <SelectContent>
                {techAreas.map(tech => (
                  <SelectItem key={tech} value={tech}>
                    {tech}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            <Select
              value={filters.scoreBand}
              onValueChange={(value) => onFilterChange('scoreBand', value)}
            >
              <SelectTrigger className="h-9 bg-background">
                <SelectValue placeholder="Score Band" />
              </SelectTrigger>
              <SelectContent>
                {scoreBands.map(band => (
                  <SelectItem key={band} value={band}>
                    {band}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onResetFilters}
              className="text-muted-foreground hover:text-foreground"
            >
              <RotateCcw className="h-4 w-4 mr-1.5" />
              Reset
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
